// extracted by mini-css-extract-plugin
export default {"categoryItem":"pointCategoryItem_categoryItem__YM1Sw","categoryName":"pointCategoryItem_categoryName__PE7mH"};